var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.isShowAppSmartBanner)?_c('AppSmartBanner'):_vm._e(),_vm._v(" "),_c('BaseContainer',{staticClass:"flex-grow-1",class:{
      'fill-height': _vm.isTelemedPage,
      'base-container_telemed': !_vm.$device.isMobile && _vm.isTelemedPage,
    }},[_vm._t("default")],2),_vm._v(" "),_c('MainDialog'),_vm._v(" "),_c('MainSnackbar'),_vm._v(" "),(_vm.shouldShowRulesAgreement)?_c('RulesAgree'):_vm._e(),_vm._v(" "),_c('TownSelect'),_vm._v(" "),_c('EnvironmentBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }